import React, { FunctionComponent } from 'react';

import { StyledContainer, StyledSpinner } from 'app/components/spinner/spinner.styled';

export const Spinner: FunctionComponent = () => (
    <StyledContainer>
        <StyledSpinner />
    </StyledContainer>
);
